import { Form, FormInstance } from 'antd'
import React, { useEffect } from 'react'
import { Formula } from '../types/Formula'
import { FormItemsConfig, FULL_FORM_CONFIG, renderFormItems } from './formItems/FormItemsConfig'

type FormData = Omit<Formula, 'style'> & { style: any }

interface FormulaFormProps {
  formulaError: any
  initialValues?: Formula
  onFormInstanceReady: (instance: FormInstance<FormData>) => void
  config?: FormItemsConfig
}

const FormulaForm: React.FC<FormulaFormProps> = ({
  formulaError,
  initialValues,
  onFormInstanceReady,
  config = FULL_FORM_CONFIG
}) => {
  const [form] = Form.useForm<FormData>()

  useEffect(() => {
    onFormInstanceReady(form)
  }, [])

  return (
    <div className="formula-editor">
      <Form form={form} layout="vertical" name="formula" initialValues={initialValues}>
        {renderFormItems(config, formulaError)}
      </Form>
    </div>
  )
}

export default FormulaForm
